import { useCallback, useEffect, useState } from "react";
import {
  Container,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Typography,
} from "@mui/material";
import TableGeneric from "../../components/Generics/TableGeneric";
import { GridColDef, GridSortModel } from "@mui/x-data-grid";
import { formatarData, useIsSmallScrenn } from "../../helper";
import { DadosSolicitacaoEmissao } from "../../model/entities/SolicitacaoEmissaoCTe";
import { useSnack } from "../../redux/snack/snackHooks";
import solicitacaoEmissaoCTeApi, {
  getStatusSolicitacaoCte,
} from "../../api/solicitacaoEmissaoCTeApi";
import Titulo2 from "../../components/Generics/Titulo2";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ModalSolicitacaoEmissaoCTe from "../../components/modais/ModalSolicitacaoEmissaoCTe";
import LoadingBackdrop from "../../components/Generics/LoadingBackdrop";
import GridCenter from "../../components/Generics/GridCenter";
import dayjs from "dayjs";

type Props = {};

const SolicitacaoCTePage: React.FC<Props> = (props) => {
  const isSmallScrenn = useIsSmallScrenn();
  const [solicitacoes, setSolicitacoes] = useState<DadosSolicitacaoEmissao[]>(
    []
  );
  const [totalLinhas, setTotalLinhas] = useState(4);
  const [loading, setLoading] = useState(false);
  const [pagina, setPagina] = useState(1);

  const [linhasPorPagina, setLinhasPorPagina] = useState(0);
  const [solicitacaoSelecionada, setSolicitacaoSelecionada] =
    useState<DadosSolicitacaoEmissao | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const mostrarSnack = useSnack();
  const rowHeight = 52;

  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "id", sort: "desc" },
  ]);

  useEffect(() => {
    setLoading(true);
    const calcularPageSize = () => {
      const alturaHeader = 56;
      const alturaFooter = 52;
      const alturaDisponivel =
        window.innerHeight - alturaHeader - alturaFooter - 200;

      const linhasVisiveis = Math.floor(alturaDisponivel / rowHeight);
      setLinhasPorPagina(linhasVisiveis > 0 ? linhasVisiveis : 1);
      setLoading(false);
    };

    calcularPageSize();
    window.addEventListener("resize", calcularPageSize);

    return () => {
      window.removeEventListener("resize", calcularPageSize);
    };
  }, []);

  const buscarSolicitacoes = useCallback(async () => {
    try {
      setLoading(true);

      const resTotal = await solicitacaoEmissaoCTeApi.count();
      setTotalLinhas(resTotal);

      var field = sortModel[0]?.field ?? "id";

      if (field === "nomeMotorista") {
        field = "motorista";
      }
      const res = await solicitacaoEmissaoCTeApi.getMany(
        pagina - 1,
        linhasPorPagina,
        field,
        sortModel[0]?.sort ?? "asc"
      );

      setSolicitacoes(res);
      setLoading(false);
    } catch (erro: any) {
      mostrarSnack(
        "Ops); Aconteceu um problema ao buscar os solicitacoes !!",
        "error"
      );
      console.log("erro ao buscar solicitacoes", erro);
      setLoading(false);
    }
  }, [pagina, linhasPorPagina, sortModel]);

  useEffect(() => {
    buscarSolicitacoes();
  }, [pagina, linhasPorPagina, sortModel]);

  const columns: GridColDef<DadosSolicitacaoEmissao>[] = [
    {
      field: "id",
      headerName: "ID",
      width: 50,
      editable: false,
    },
    {
      field: "nomeMotorista",
      headerName: "Motorista",
      width: 260,
      editable: false,
    },
    {
      field: "numeroNota",
      headerName: "Número da Nota",
      width: 200,
      editable: false,
    },
    {
      field: "placaVeiculo",
      headerName: "Placa do Veículo",
      width: 150,
      editable: false,
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      editable: false,
      renderCell: (params) => {
        return getStatusSolicitacaoCte(params.row);
      },
    },
    {
      field: "dataHoraSolicitacao",
      headerName: "Data",
      editable: false,
      renderCell: (params) => {
        return formatarData(params.row.dataHoraSolicitacao.toString());
      },
    },

    {
      field: "acoes",
      headerName: "Ações",
      width: 80,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const solicitacao = params.row;
        return (
          <>
            <IconButton onClick={(e) => e.stopPropagation()}>
              <VisibilityIcon
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setSolicitacaoSelecionada(solicitacao);
                  setOpenModal(true);
                }}
              />
            </IconButton>
          </>
        );
      },
    },
  ];

  if (loading) {
    return (
      <>
        <LoadingBackdrop open={loading} />
      </>
    );
  }

  return (
    <Grid spacing={2} style={{ display: "flex", justifyContent: "center" }}>
      <Container style={{ marginBottom: "15px" }}>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Titulo2>Solicitações para emissão de CT-e </Titulo2>
        </Grid>

        {isSmallScrenn ? (
          <>
            {solicitacoes.map((solicitacao) => (
              <GridCenter>
                <Paper
                  style={{
                    margin: "12px 0px",
                    padding: "12px",
                    width: "100%",
                    borderRadius: "16px",
                  }}
                  key={solicitacao.id}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      {getStatusSolicitacaoCte(solicitacao)}
                    </Grid>
                    <Grid item xs={12}>
                      <Typography fontWeight={"bold"}>
                        {solicitacao.nomeMotorista}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography>
                        Número da Nota: {solicitacao.numeroNota}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography>
                        Placa do Veículo: {solicitacao.placaVeiculo}
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography>
                        Data Solicitação{" "}
                        {dayjs(solicitacao.dataHoraSolicitacao).format(
                          "DD/MM/YYYY - HH:MM"
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "right" }}>
                      <IconButton>
                        <VisibilityIcon
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSolicitacaoSelecionada(solicitacao);
                            setOpenModal(true);
                          }}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Paper>
              </GridCenter>
            ))}
            <GridCenter>
              <Pagination
                size={"large"}
                defaultPage={1}
                count={totalLinhas / linhasPorPagina}
                onChange={(event, number) => setPagina(number)}
                page={pagina}
              />
            </GridCenter>
          </>
        ) : (
          <Grid item xs={12}>
            <TableGeneric
              pageSize={linhasPorPagina}
              colunas={columns}
              linhas={solicitacoes}
              loading={loading}
              totalLinhas={totalLinhas}
              selecionaLinha={false}
              paginaAtual={pagina - 1}
              sx={{ height: "50%" }}
              rowHeight={52}
              sortModel={sortModel}
              setSortModel={setSortModel}
              onRowClick={(params) => {
                setSolicitacaoSelecionada(params.row);
                setOpenModal(true);
              }}
              formasDeListar={[5, 10]}
              setPaginacao={(model) => {
                setPagina(model.page);
                setLinhasPorPagina(model.pageSize);
              }}
            />
          </Grid>
        )}
      </Container>

      {openModal && solicitacaoSelecionada && (
        <ModalSolicitacaoEmissaoCTe
          open={openModal}
          solicitacao={solicitacaoSelecionada}
          onClose={() => {
            buscarSolicitacoes();
            setOpenModal(false);
            setSolicitacaoSelecionada(null);
          }}
        />
      )}
    </Grid>
  );
};

export default SolicitacaoCTePage;
